import DOMPurify from "dompurify";

/**
 * Sanitizes HTML content specifically for task lists to prevent XSS attacks
 * while preserving the necessary task list structure and attributes.
 */
export function sanitizeTaskContent(html: string): string {
    // Configure DOMPurify to allow only task-related elements and attributes
    const config = {
        ALLOWED_TAGS: [
            "ul",
            "li",
            "div",
            "p",
            "br",
            "strong",
            "b",
            "em",
            "i",
            "u",
            "s",
            "strike",
            "del",
            "input",
            "label",
        ],
        ALLOWED_ATTR: ["data-type", "data-checked", "class", "type", "checked", "disabled"],
        // Keep data attributes for task functionality
        ALLOW_DATA_ATTR: true,
        // Don't allow any scripts or event handlers
        FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "link"],
        FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "onblur"],
    };

    return DOMPurify.sanitize(html, config) as string;
}
